import withErrorCheck from "../CheckError";
import server from "../Server";
import type { GetGroupTopAssistsPayload, ITopAssists } from "@grassrootly/api/entities";

// Fetch top 10 assist makers for a group from player_games_view
export const GetGroupTopAssists = async ({ groupId }: GetGroupTopAssistsPayload): Promise<ITopAssists[]> => {
  const response = await server
    .from("player_games_view")
    .select([
      "player_id",
      "player_name", 
      "player_profile_picture",
      "player_assists_made",
      "game_datetime",
      "game_id"
    ].join(","))
    .eq("group_id", groupId)
    .gt("player_assists_made", 0) // Only include games where assists were made
    .order("player_assists_made", { ascending: false })
    .order("game_datetime", { ascending: false }) // Secondary sort by most recent
    .limit(10);

  const data = withErrorCheck<ITopAssists[]>(response as any) || [];
  return data;
};
